import React from 'react';
import { ShopBuyerCouponsFragment } from './rql';

interface ICouponContext {
  coupon: ShopBuyerCouponsFragment.BuyerCoupons,
}

export default React.createContext<ICouponContext>({ coupon: null });
